<script setup lang="ts">
import { computed } from 'vue';

type Props = {
  modelValue: boolean;
  iconSize?: 1 | 2 | 3 | 4;
};

const props = withDefaults(defineProps<Props>(), {
  iconSize: 2,
});

const emits = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const hover = computed({
  get: () => props.modelValue,
  set: value => {
    emits('update:modelValue', value);
  },
});
</script>

<template>
  <div class="flex h-auto">
    <v-icon
      :color="hover ? 'iconSolid' : 'iconThin'"
      :icon="`${hover ? 'fas' : 'fat'} fa-circle-info`"
      :class="`text-icon-${props.iconSize}`"
      @mouseleave="hover = false"
      @mouseover="hover = true"
    >
    </v-icon>
  </div>
</template>
